// frontend/src/context/AIContext.jsx
import React, { createContext, useState } from "react";

export const AIContext = createContext();

export const AIProvider = ({ children }) => {
  const [isAIOpen, setIsAIOpen] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);

  const resetAI = () => {
    setIsAIOpen(false);
    setChatHistory([]);
    localStorage.removeItem("ai_open");
    localStorage.removeItem("ai_history");
  };

  return (
    <AIContext.Provider value={{ isAIOpen, setIsAIOpen, chatHistory, setChatHistory, resetAI }}>
      {children}
    </AIContext.Provider>
  );
};
